import { Flex, Link, Image, Text } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { UserProfile } from '../../service/social';
import config from '../../config';
import { getUserName } from '../../service/lobby';
import { SubscriptionDef } from '../../service/inventory';

interface SubscriptionListItemProps {
    subcription: SubscriptionDef;
    profile: UserProfile;
}

export const SubscriptionListItem: React.FC<SubscriptionListItemProps> = ({
    subcription,
    profile,
}) => {
    return (
        <Flex className={'follower-list-item'}>
            {profile && (
                <>
                    <Link as={ReactRouterLink} to={`/user/${profile.id}`}>
                        <Image
                            className={'follower-avatar-image'}
                            src={
                                profile.avatar_object_url ||
                                profile.twitch_profile?.profile_image_url ||
                                config.avatarPlaceholderURL
                            }
                        />
                    </Link>
                    <Flex className="subscription-info">
                        <Text className={'subscription-username'}>{getUserName(profile)}</Text>
                        <Text>{subcription.subscription_item.item_name}</Text>
                        <Text>
                            Expires: {new Date(subcription.expire_time * 1000).toLocaleDateString()}
                        </Text>
                    </Flex>
                </>
            )}
        </Flex>
    );
};
